@if (notifications().length > 0) {
  <div class="notifications-anchor">
    <button
      comp-button="tertiary"
      type="button"
      id="notifications"
      [matMenuTriggerFor]="notificationsMenu"
      [attr.title]="'header.notifications_tooltip' | translate"
    >
      <i comp-icon [class.-ringing]="notificationPreview().length > 0"> notifications </i>
    </button>

    @if (notificationPreview().length > 0) {
      <div
        class="notification-preview notification-surface"
        [class.-closing]="notificationPreviewClosing()"
        role="status"
        aria-live="polite"
      >
        @for (notification of notificationPreview(); track notification) {
          <div class="notification-item">
            {{ notification.key | translate: notification.params }}
          </div>
        }
      </div>
    }

    <mat-menu #notificationsMenu="matMenu" class="notifications-menu">
      <div class="notification-surface">
        @for (notification of notifications(); track notification) {
          <div class="notification-item">
            {{ notification.key | translate: notification.params }}
          </div>
        }
      </div>
    </mat-menu>
  </div>
}
